// Utility functions for formatting and parsing inputs

// Format number as currency (USD)
export const formatCurrency = (value) => {
  if (!value) return ""; // Handle empty or undefined values

  // Remove non-numeric characters except for the decimal point
  let numberValue = parseFloat(value.replace(/[^\d.-]/g, "")) || 0;

  // Format the number as currency
  return numberValue.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

// Parse currency to remove formatting
export const parseCurrency = (value) => {
  return parseFloat(value.replace(/[^\d.-]/g, "")) || 0;
};

// Strip all non-numeric characters from phone number
export const stripPhoneNumber = (value) => {
  return value.replace(/\D/g, "");
};

// Format phone number for display
export const formatPhoneNumber = (value) => {
  if (!value) return "";

  // Strip non-numeric characters first
  const digits = stripPhoneNumber(value);

  // Format based on length
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length === 11 && digits.startsWith("1")) {
    // Handle 11-digit numbers starting with 1 (US country code)
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(
      7
    )}`;
  } else if (digits.length === 7) {
    // Handle 7-digit numbers
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  } else {
    // Return as-is if it doesn't match expected patterns
    return digits;
  }
};

// Format phone number as user types (for input fields)
export const formatPhoneNumberAsTyped = (value) => {
  if (!value) return "";

  // Strip non-numeric characters
  const digits = stripPhoneNumber(value);

  // Format based on length
  if (digits.length <= 3) {
    return digits;
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  } else if (digits.length <= 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else {
    // For longer numbers, just format the first 10 digits
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
      6,
      10
    )}`;
  }
};
